var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{staticClass:"custom-options",attrs:{"data-testid":"bundle-options"}},_vm._l((_vm.product.bundle_options),function(option){return _c('div',{key:('bundleOption_' + option.option_id)},[_c('product-bundle-option',{attrs:{"option":option,"error-messages":_vm.errorMessages},on:{"option-changed":_vm.optionChanged}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }